import React from 'react';
import { View, Text, RefreshControl, ScrollView } from 'react-native-web';

import { connect } from 'react-redux';

import { fetchJourneys } from "../../redux/actions";

import get from "../../api/methods/get";
import { QUERY_TAGS } from "./api/journeyEndpoints";


import Colors from '../../constants/Colors';
import NavBar from '../../components/NavBar';
import {  SpinnerControl } from "../../components";

import TagListRender from "./components/TagListRender";

class JourneyScreen extends React.Component {

    state = {
        isFetching: false,

        tagData: [],
        taggedJourneys: [],
    }

    fetchJourneys = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });

        try {
            await this.props.fetchJourneys();

            let tagResult = await get(QUERY_TAGS);
            let tagJson = await tagResult.json();

            const userJourneys = [...this.props.userCompletedJourneys, ...this.props.userInProgressJourneys];
            const allJourneys = this.props.allJourneys;

            let tagMap = new Map();
            tagMap.set("notag", { tagId: "notag", tagName: "Jornadas", journeys: [] });

            const filteredJourneys = allJourneys.filter(item => {
                //Checar se a jornada esta na lista do usuario
                const checkInclusion = userJourneys.findIndex(i => i.id === item.id);

                if (checkInclusion !== -1) {
                    return;
                }

                if (item.tags.length === 0) {
                    let noTagJourneys = tagMap.get("notag");
                    noTagJourneys.journeys.push(item);
                    tagMap.set("notag", noTagJourneys)
                } else {

                    for (let tag of item.tags) {

                        if (tagMap.has(tag) === false) {
                            const specificTag = tagJson.data.find(i => i.SK === tag);
                            tagMap.set(tag, { tagId: tag, journeys: [], tagName: specificTag.tagName, ordering: specificTag.ordering })
                        }

                        let taggedElement = tagMap.get(tag);
                        taggedElement.journeys.push(item);
                        tagMap.set(tag, taggedElement);
                    }
                }

                return item;
            });

            const orderedData = Array.from(tagMap.values()).sort((a, b) => {
                if (a.ordering > b.ordering) return 1;
                else return -1;
            })

            this.setState({ tagData: tagJson.data, taggedJourneys: orderedData });

        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false });
    }

	componentDidMount() {
		this.fetchJourneys();
	}

	render() {
		return (
			<NavBar title={'Novos Treinamentos'}>
				<View style={{ flex: 1, backgroundColor: Colors.backgroundColor }}>
					<ScrollView>
						<SpinnerControl
                            isFetching={this.state.isFetching}
                            textPropsStyle={{ color: Colors.spinnerNoBackgroundTextColor }}
                            text={"Carregando!"}
                        />

						{
							this.state.taggedJourneys.map(item => {
								return <TagListRender key={item.tagId.toString()} tagName={item.tagName} journeys={item.journeys} />
							})
						}
					</ScrollView>
				</View>
			</NavBar>
		)
	}
}

const mapStateToProps = state => {
	return {
		allJourneys: state.journey.allJourneys,
		userInProgressJourneys: state.journey.userInProgressJourneys,
		userCompletedJourneys: state.journey.userCompletedJourneys,
	}
}

export default connect(mapStateToProps, { fetchJourneys } )(JourneyScreen);

